import { DialogContent } from "@mui/material";

import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";
import { ViewVariant } from "@/common/ts/layout";

import VehicleActualStateView, { VehicleActualStateProps } from "./VehicleActualStateView";

export interface OwnProps {
  subProps: VehicleActualStateProps;
}

type Props = OwnProps & AppModalProps;

export default function VehicleActualStateModal({ subProps, ...modalProps }: Props) {
  const openStatus = useModalOpenStatus(modalProps);

  return (
    <AppModal fullWidth maxWidth='lg' {...modalProps}>
      <DialogContent>
        {openStatus.isOpen && (
          <VehicleActualStateView
            {...subProps}
            headerProps={{
              withLink: true,
              typographyProps: {
                variant: "h1",
              },
              ...subProps?.headerProps,
            }}
            displayProps={{
              viewVariant: ViewVariant.Modal,
              closeInHeader: true,
              breadcrumbs: false,
              ...subProps?.displayProps,
            }}
            onClose={() => {
              modalProps.onClose?.({}, "backdropClick");
              subProps.onClose?.();
            }}
          />
        )}
      </DialogContent>
    </AppModal>
  );
}
